import { TUseScroll } from "./useScroll.config";

export const useScroll = (): TUseScroll => {
  const scrollToId = (id: string): void => {
    const element = document.getElementById(id);

    if (!element) { return; }

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    element.scrollIntoView({
      behavior: prefersReducedMotion ? "instant" : "smooth",
      block: "start",
    });
  };

  return {
    scrollToId,
  };
};
